import React from 'react';
import { Check, X } from 'lucide-react';
import { AUTOCALIFICABLES, maximoDe } from '../../../lib/formularios';

/*
 * Controles para calificar a mano una pregunta de una respuesta (vista Individual).
 * `resultado` = la entrada guardada de `puntuacion.por_pregunta[item.id]`;
 * `edicion`   = lo que se cambió aquí y aún no se guarda ({puntos, retro}).
 */

export function puntosDe(item, resultado, edicion) {
  if (edicion && edicion.puntos !== undefined) return edicion.puntos;
  return resultado?.puntos ?? 0;
}

export default function CalificarRespuesta({ item, resultado, edicion, onCambio, deshabilitado }) {
  const maximo = resultado?.maximo ?? maximoDe(item);
  const puntos = puntosDe(item, resultado, edicion);
  const retro = edicion?.retro !== undefined ? edicion.retro : (resultado?.retro || '');
  const auto = AUTOCALIFICABLES.includes(item.tipo) && resultado && !resultado.manual && edicion?.puntos === undefined;
  const correctasTexto = item.tipo === 'texto_corto' && Array.isArray(item.clave?.correctas) ? item.clave.correctas : [];

  let estado = 'Sin calificar';
  if (edicion?.puntos !== undefined || resultado?.manual) estado = 'Calificada a mano';
  else if (resultado?.correcta === true) estado = 'Correcta · automática';
  else if (resultado?.correcta === false) estado = 'Incorrecta · automática';

  const idPuntos = `rs-puntos-${item.id}`;
  const idRetro = `rs-retro-${item.id}`;

  return (
    <div className="rs-calificar">
      {correctasTexto.length > 0 && (
        <div className="fr-correctas">
          <div className="fr-correctas-titulo">Respuestas correctas</div>
          <ul>{correctasTexto.map((c) => <li key={c}>{c}</li>)}</ul>
        </div>
      )}
      <div className="rs-calificar-fila">
        <span className={`rs-calificar-estado ${auto ? 'is-auto' : ''}`}>{estado}</span>
        <div className="rs-calificar-puntos">
          <button
            type="button"
            className="rs-calificar-rapido is-bien"
            onClick={() => onCambio({ puntos: maximo })}
            disabled={deshabilitado}
            aria-label="Marcar como correcta (todos los puntos)"
            title="Correcta"
          >
            <Check className="h-4 w-4" />
          </button>
          <button
            type="button"
            className="rs-calificar-rapido is-mal"
            onClick={() => onCambio({ puntos: 0 })}
            disabled={deshabilitado}
            aria-label="Marcar como incorrecta (0 puntos)"
            title="Incorrecta"
          >
            <X className="h-4 w-4" />
          </button>
          <label className="sr-only" htmlFor={idPuntos}>Puntos</label>
          <input
            id={idPuntos}
            type="number"
            inputMode="decimal"
            min={0}
            max={maximo}
            step="any"
            className="rs-calificar-input"
            value={puntos}
            disabled={deshabilitado}
            onChange={(e) => {
              const n = e.target.value === '' ? 0 : Number(e.target.value);
              if (Number.isNaN(n)) return;
              onCambio({ puntos: Math.min(Math.max(n, 0), maximo) });
            }}
          />
          <span className="rs-calificar-de">/ {maximo}</span>
        </div>
      </div>
      <label className="rs-calificar-retro-etiqueta" htmlFor={idRetro}>Comentarios para quien respondió</label>
      <textarea
        id={idRetro}
        className="rs-calificar-retro"
        rows={2}
        placeholder="Añadir comentarios"
        value={retro}
        disabled={deshabilitado}
        onChange={(e) => onCambio({ retro: e.target.value })}
      />
    </div>
  );
}
